import HelpBlock from '../../components/helpBlock/HelpBlock.svelte'
import ListBlock from '../../components/listBlock/ListBlock.svelte'
import { type Component } from 'svelte'

export const pricingFeaturesComponents = [
	{
		__typename: 'ListRecord',
		component: ListBlock as unknown as Component,
	},
	{
		__typename: 'HelpRecord',
		component: HelpBlock as unknown as Component,
	},
]
